import * as React from 'react';

//👻 SALE 25%
export const SaleComponent = () => <></>;

//halloween-button, black-friday-button
export const SaleButtonClassName = '';
